import { SessionsWidgetData } from './types';

export const defaultSessionsWidgetState: SessionsWidgetData = {
  sessions: {},
};
